export default __webpack_public_path__ + "static/media/pune.703e5acc.jpg";